<template>
	<div class="c-zn-forms container">
		<div class="c-zn-forms-sidebar" :class="filterOpen ? 'is-active' : ''" v-scroll-lock="filterOpen">
			<Search v-model="searchTerm" />

			<div class="c-zn-form-filter">
				<div class="c-zn-form-filter__mobile-header">
					<span>Filteren en sorteren</span>
					<button
						class="c-zn-form-filter__mobile__close"
						@click="filterOpen = false"
						aria-label="Sluit filter"
					>
						<svg class="icon icon-icon_close_dark"><use xlink:href="#icon-icon_close_dark"></use></svg>
					</button>
				</div>
				<fieldset>
					<div class="show-mobile c-zn-form-mobilesort">
						<FormSort v-model="orderBy" />
					</div>

					<div class="c-zn-form-radiobtn c-zn-form-filtercat">
						<input type="radio" name="all" id="all" v-model="folderFilter" value="" />
						<label class="c-zn-forms-sidebar__label" for="all">Alle documenten</label>
					</div>
					<template v-for="folder in data.folders">
						<div class="c-zn-form-radiobtn c-zn-form-filtercat" v-if="folder.children.length <= 0">
							<input
								type="radio"
								:name="folder.slug"
								:id="folder.slug"
								v-model="folderFilter"
								:value="folder"
							/>
							<label class="c-zn-forms-sidebar__label" :for="folder.slug">{{ folder.name }}</label>
						</div>

						<FilterDropdown :label="folder.name" @close="filterOpen = false" v-else>
							<div class="c-zn-form-radiobtn c-zn-form-radiobtn--secondary" v-show="!folder.hideOverview">
								<input
									type="radio"
									:name="folder.slug"
									:id="folder.slug"
									v-model="folderFilter"
									:value="folder"
								/>
								<label :for="folder.slug">Alle documenten</label>
							</div>
							<div
								class="c-zn-form-radiobtn c-zn-form-radiobtn--secondary"
								v-if="folder.slug === 'farmacie' || folder.slug == 'ciebag'"
							>
								<input
									type="radio"
									:name="folder.slug + '_last_updated'"
									:id="folder.slug + '_last_updated'"
									v-model="folderFilter"
									:value="{
										name: 'Laatst gewijzigd',
										type: 'last_updated',
										slug: folder.slug + '_last_updated',
										originalSlug: folder.slug,
									}"
								/>
								<label :for="folder.slug + '_last_updated'">Laatst gewijzigd</label>
							</div>
							<div
								class="c-zn-form-radiobtn c-zn-form-radiobtn--secondary"
								v-for="child in folder.children"
							>
								<input
									type="radio"
									:name="child.slug"
									:id="child.slug"
									v-model="folderFilter"
									:value="child"
								/>
								<label :for="child.slug">{{ child.name }}</label>
							</div>
						</FilterDropdown>
					</template>
				</fieldset>
			</div>
		</div>
		<div class="c-zn-forms-container">
			<Search v-model="searchTerm" />

			<h2 class="c-zn-forms-title">{{ texts.label }} ({{ cardAmount }})</h2>

			<p v-if="texts.text" class="c-zn-form-text" v-html="texts.text"></p>

			<a :href="texts.more_info.url" v-if="texts.more_info" class="c-zn-form-link">
				{{ texts.more_info.title }}
				<svg class="icon icon-icon-arrow_right"><use xlink:href="#icon-icon-arrow_right"></use></svg>
			</a>

			<button @click="filterOpen = true" class="c-zn-forms-filter__open">
				<svg class="icon icon-settings"><use xlink:href="#icon-settings"></use></svg>
				Filters en sorteren
			</button>

			<div class="hide-mobile">
				<FormSort v-model="orderBy" />
			</div>

			<div class="c-zn-form-cardcontainer">
				<template v-for="card in cards">
					<FormCard :data="card" v-if="card.type == 'singleCard'" />

					<FormGroupedCard :card="card" v-if="card.type == 'groupedCard'" />
				</template>

				<div class="c-zn-form__noresults" v-if="cardAmount <= 0 && isSearching">
					<h3>We hebben niets gevonden voor '{{ searchTerm }}'</h3>

					<div class="c-zn-form__resultexplainer">
						<span>Probeer 1 van deze zoektips</span>
						<ul>
							<li>Check je spelling.</li>
							<li>Probeer een ander zoekwoord.</li>
							<li>Maak je zoekopdracht niet te lang. Kies 2 à 3 relevante woorden.</li>
						</ul>
					</div>
				</div>

				<div class="c-zn-form__noresults" v-if="cardAmount <= 0 && !isSearching">
					<h3>Er zijn geen formulieren gevonden</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Search from './FormSearch.vue';
import FormCard from './FormCard.vue';
import FormGroupedCard from './FormGroupedCard.vue';
import FilterDropdown from './FilterDropdown.vue';
import FormSort from './FormSort.vue';

export default {
	name: 'Forms',
	components: {
		Search,
		FormCard,
		FilterDropdown,
		FormGroupedCard,
		FormSort,
	},
	props: {
		data: Object,
	},
	data() {
		return {
			folderFilter: '',
			orderBy: 'name',
			cards: this.data.forms,
			filteredCollection: this.data.forms,
			groupedCards: this.data.groupedCards,
			filterOpen: false,
			searchTerm: '',
			isSearching: false,
			dateFolders: [],
		};
	},
	mounted() {
		const url = new URL(window.location.href);
		const paramFolder = url.searchParams.get('filter') ?? '';
		if (paramFolder) {
			if (paramFolder.includes('last_updated')) {
				this.folderFilter = {
					name: 'Laatst gewijzigd',
					type: 'last_updated',
					slug: paramFolder,
					originalSlug: paramFolder.replace('_last_updated', ''),
				};
			}

			this.data.folders.forEach((folder) => {
				if (folder.slug == paramFolder) {
					this.folderFilter = folder;
				}

				if (folder.children) {
					folder.children.forEach((subFolder) => {
						if (subFolder.slug == paramFolder) {
							this.folderFilter = subFolder;
						}
					});
				}
			});
		}
		this.dateFolders = this.data.dateFolders;

		this.orderBy = url.searchParams.get('orderBy') ?? 'name';
	},
	computed: {
		cardAmount() {
			return this.cards.length;
		},
		texts() {
			if (this.folderFilter.parent) {
				const parent = this.data.folders.find((x) => x.id === this.folderFilter.parent);
				const label = `${parent.name} / ${this.folderFilter.name}`;

				return {
					label: label,
					text: parent.description,
					more_info: parent.more_info,
				};
			}

			if (this.folderFilter) {
				const label = this.folderFilter.name;

				return {
					label: this.folderFilter.name,
					text: this.folderFilter.description,
					more_info: this.folderFilter.more_info,
				};
			}

			return {
				label: 'Alle documenten',
				text: this.data.standardText,
			};
		},
	},
	watch: {
		orderBy() {
			let result = [];

			if (this.orderBy == 'name') {
				result = this.cards.sort((a, b) => {
					return a.title.localeCompare(b.title);
				});
			}

			if (this.orderBy == 'date') {
				result = this.cards.sort((a, b) => {
					return new Date(b.date) - new Date(a.date);
				});
			}

			this.cards = result;
		},
		folderFilter() {
			this.searchTerm = '';
			this.cards = this.data.forms;
			this.filterOpen = false;

			let url = new URL(window.location.href);

			document.getElementById('znforms').scrollIntoView();

			if (this.folderFilter.grouped) {
				this.cards = this.data.groupedCards;
			}

			if (!this.folderFilter) {
				this.filteredCollection = this.cards;
				url.searchParams.delete('filter');
				window.history.pushState({}, '', url);
				return;
			}

			url.searchParams.set('filter', this.folderFilter.slug);

			if(
				this.dateFolders.includes(this.folderFilter.slug)
				|| /last_updated$/.test(this.folderFilter.slug)
			) {
				this.orderBy = 'date';
			}else{
				this.orderBy = 'name';
			}
			window.history.pushState({}, '', url);

			if (this.folderFilter.type === 'last_updated') {
				this.cards = this.cards.filter((card) => {
					// debugger;
					let include = false;
					card.folder.forEach((folder) => {
						if (
							folder.slug == this.folderFilter.originalSlug &&
							card.was_modified_last_30_days &&
							card.ignore_last_modified == false
						) {
							include = true;
						}
					});

					return include;
				});

				this.cards.sort((a, b) => {
					return new Date(b.date_modified) - new Date(a.date_modified);
				});

				this.filteredCollection = this.cards;
				return;
			}

			this.cards = this.cards.filter((card) => {
				let include = false;
				card.folder.forEach((folder) => {
					if (folder.slug == this.folderFilter.slug) {
						include = true;
					}
				});

				card.tags?.forEach((tags) => {
					if (tags.slug == this.folderFilter.slug) {
						include = true;
					}
				});

				return include;
			});

			this.filteredCollection = this.cards;
		},
		searchTerm() {
			let normalisedSearchTerm = this.searchTerm.toLowerCase();

			if (normalisedSearchTerm == '') {
				this.isSearching = false;
				this.cards = this.filteredCollection;
				return;
			}

			this.cards = this.filteredCollection.filter((card) => {
				let include = false;
				include = this.checkToIncludeInSearchResults(card);

				if (card.forms) {
					card.forms.forEach((form) => {
						include = this.checkToIncludeInSearchResults(form);
					});
				}

				return include;
			});

			this.isSearching = true;
		},
	},
	methods: {
		checkToIncludeInSearchResults(card) {
			let include = false;
			let normalisedSearchTerm = this.searchTerm.toLowerCase();

			if (card.title.toLowerCase().includes(normalisedSearchTerm)) {
				include = true;
			}

			if (card.tags.length > 0) {
				card.tags.forEach((tag) => {
					if (tag.name.toLowerCase().includes(normalisedSearchTerm)) {
						include = true;
					}
				});
			}

			if (card.znform_id && card.znform_id.toLowerCase().includes(normalisedSearchTerm)) {
				include = true;
			}

			return include;
		},
	},
};
</script>
